"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MVPickerAlternative1 = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
const $ = require("jquery");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
const Utilities_1 = require("../../../javascript/Utilities");
const ExternalInputNew_1 = require("./../ExternalInputs/ExternalInputNew");
const MVPickerAlternative1Controls_1 = require("./MVPickerAlternative1Controls");
const Base_1 = require("../../../model/Base");
class MVPickerAlternative1 extends ExternalInputNew_1.ExternalInputNew {
    constructor(controlColl, currentInstance, methodName = undefined, buttonControlDef = undefined) {
        super(controlColl, currentInstance, methodName);
        this.methodName = methodName;
        this.buttonControlDef = buttonControlDef;
        this.control = undefined;
        // this.mode = PropertyPageMode.View; // Nur zu Testzwecken aktivieren
        this.windowContentCssClass = "eiMVPickerAlternative1";
        this.windowWidth = 600;
        this.windowHeight = 300;
        this.windowResizeable = true;
    }
    IsReadOnly() {
        let that = this;
        return (that.mode === Base_1.PropertyPageMode.View || (that.input && that.input.readonlyForExtInput));
    }
    addValue(valueFTKey, valueFTField) {
        let that = this;
        that.control = new MVPickerAlternative1Controls_1.MVPAlt1Combobox(that, "mvpalt1id", {
            typeId: that.typeId,
            mode: that.mode,
            currentInstance: that.currentInstance,
            controlKey: that.controlKey,
            input: that.input,
            controlColl: that.controlColl,
            buttonControlDef: that.buttonControlDef,
            readOnly: that.IsReadOnly(),
        });
        that.control.init(that.widgetContainer);
        if (valueFTKey !== "") {
            let value = { id: valueFTKey, value: valueFTField };
            that.control.setValue(value);
        }
        return that.control;
    }
    initWindowContents() {
        let that = this;
        let errorMessage = "";
        if (!that.controlColl.Input.field.isFTField)
            errorMessage = that.controlColl.Input.field.fieldName + " is not a FT-Field. This MV-Picker-Dialog do not support this field type.";
        else if (!that.controlColl.Input.field.multiValue)
            errorMessage = that.controlColl.Input.field.fieldName + " is not a multivalue Field. This MV-Picker-Dialog do not support this field type.";
        else if (that.controlColl.Input.mode === Base_1.PropertyPageMode.Search)
            errorMessage = "This MV-Picker-Dialog does not support the search mode.";
        if (errorMessage === "")
            that.updateDialog(that.currentInstance);
        else {
            // Konfigurationsfehler!
            $.errorDialog({
                ErrorDisplayMessage: errorMessage
            });
        }
        return Promise.resolve();
    }
    compare(a, b) {
        if (a[1] < b[1])
            return -1;
        if (a[1] > b[1])
            return 1;
        return 0;
    }
    getUpdatedInstance() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            let resultNoSort = yield that.getUpdatedInstanceNoSort();
            let ftName = that.controlColl.Input.field.foreignTableName;
            let sortOrder = Utilities_1.synUtil.Configs.getValue("cefunc.249.ftsortorder." + ftName, "1", resultNoSort.instance.items["cgdocument.typeid"].valueToNumber(1));
            switch (sortOrder) {
                case "1": {
                    // Alphabetische Sortierung nach angezeigtem FT-Feld
                    let valuesResult = that.getValuesAsArray();
                    valuesResult.values.sort(that.compare);
                    that.setValuesToInstance(valuesResult.values, resultNoSort.instance);
                    return Promise.resolve(resultNoSort);
                }
                case "2": {
                    // Reihenfolge so, wie es der Benutzer eingegeben hat --> nix zu tun!
                    return Promise.resolve(resultNoSort);
                }
                default:
                    {
                        // Sortierung laut classvalue
                        let requestedIds = [];
                        let valuesResult = that.getValuesAsArray();
                        if (valuesResult.values.length > 0) {
                            for (let xValue = 0; xValue < valuesResult.values.length; xValue++) {
                                let value = valuesResult.values[xValue];
                                requestedIds.splice(xValue, 0, value[0]);
                            }
                            let ftFieldName = that.controlColl.Input.field.fieldName;
                            let ftIdFieldName = that.controlColl.Input.field.foreignTableName + ".id";
                            let ftColumnName = that.controlColl.Input.field.fieldName.split(".")[1];
                            let ftIdColumnName = "id";
                            let ftData = {
                                requestedIds,
                                includeSoftDeletedEntries: true,
                                columns: [ftIdFieldName, ftFieldName],
                                orderBy: sortOrder
                            };
                            let urlName = Utilities_1.synUtil.getWSUrl("ForeigntableEntries") + ftName + "/";
                            try {
                                let ftEntries = yield Utilities_1.synUtil.getAJAXDataAsync({
                                    method: "POST",
                                    url: urlName,
                                    requestData: JSON.stringify(ftData),
                                });
                                let sortedArray = new Array();
                                for (let xValue = 0; xValue < ftEntries.items.length; xValue++) {
                                    let ftEntry = ftEntries.items[xValue];
                                    sortedArray.splice(xValue, 0, [ftEntry[ftIdColumnName], ftEntry[ftColumnName]]);
                                }
                                that.setValuesToInstance(sortedArray, resultNoSort.instance);
                                return Promise.resolve(resultNoSort);
                            }
                            catch (ex) {
                                Utilities_1.synUtil.getAJAXDataFail(ex, undefined, undefined, urlName);
                                return Promise.reject(ex);
                            }
                        }
                        else
                            return Promise.resolve(resultNoSort);
                    }
            }
        });
    }
    getValuesAsArray() {
        let that = this;
        let bDuplicateFound = false;
        let returnArray = new Array();
        if (that.control) {
            let multiValues = that.control.getValue();
            let uniqueValues = new Array();
            for (let xValue = 0; xValue < multiValues.length; xValue++) {
                let value = multiValues[xValue];
                let bAdd = true;
                for (let xUniqueValue = 0; xUniqueValue < uniqueValues.length; xUniqueValue++) {
                    let uniqueValue = uniqueValues[xUniqueValue];
                    if (value.id === uniqueValue) {
                        bDuplicateFound = true;
                        bAdd = false;
                        break;
                    }
                }
                if (bAdd) {
                    uniqueValues.push(value.id);
                    returnArray.splice(xValue, 0, [value.id, value.value]);
                }
            }
        }
        return { values: returnArray, duplicateFound: bDuplicateFound };
    }
    setValuesToInstance(array, instance) {
        let valuesFTKey = [];
        let valuesFTField = [];
        for (let xValue = 0; xValue < array.length; xValue++) {
            let value = array[xValue];
            valuesFTKey.splice(xValue, 0, value[0]);
            valuesFTField.splice(xValue, 0, value[1]);
        }
        instance.items[this.input.field.presentedField].value = valuesFTKey;
        instance.items[this.input.field.fieldName].value = valuesFTField;
    }
    getUpdatedInstanceNoSort() {
        let that = this;
        let result = new ExternalInputNew_1.ExternalInputResultData();
        let arrayResult = that.getValuesAsArray();
        if (arrayResult.duplicateFound) {
            result.errorCode = 1;
            result.errorText = Utilities_1.synUtil.Strings.getValue("dynpmvalt1dupfound", "Duplicate entry found");
        }
        let inst = that.currentInstance;
        that.setValuesToInstance(arrayResult.values, inst);
        result.instance = inst;
        return Promise.resolve(result);
    }
    updateDialog(instance) {
        let that = this;
        that.clear();
        that.currentInstance = instance;
        that.addValue("", "");
        let fieldNameFTKey = that.input.field.isFTRepresentativeField ?
            that.input.field.presentedField : that.input.field.fieldName;
        let fieldNameFTField = that.input.field.fieldName;
        let currentValuesFTKey = that.currentInstance.items[fieldNameFTKey].valueAsArray;
        let currentValuesFTField = that.currentInstance.items[fieldNameFTField].valueAsArray;
        for (let ii = 0; ii < currentValuesFTKey.length; ii++) {
            let valueFTKey = currentValuesFTKey[ii];
            let valueFTField = currentValuesFTField[ii];
            that.control.addMultiValue({ id: valueFTKey, value: valueFTField });
        }
        that.control.notifyChange();
        that.adjustDialogHeight();
        if (that.IsReadOnly())
            // In diesem Fall darf das editierbare Control nicht angezeigt werden
            that.control.controlContainer.hide();
        else {
            that.scrollToBottom();
            that.control.valueControl.getInputControl().focus();
        }
    }
    scrollToBottom() {
        let that = this;
        if ($(that.control.controljQueryElem).length > 0)
            $(that.control.controljQueryElem)[0].scrollTop = $(that.control.controljQueryElem)[0].scrollHeight;
    }
    adjustDialogHeight() {
        if (Utilities_1.synUtil.clientDeviceClass !== "phone") {
            let that = this;
            let maxWindowHeight = window.innerHeight - 70; // Dieser Wert wurde empirisch ermittelt
            let iHeightAllItems = that.control.getHeightAllItems() + 10; // 10px werden als Rand dazugegeben, da ein bißchen "Platz" sein sollte und außerdem ist entweder der Wert von getHeightAllItems oder getHeightContainer nicht ganz korrekt.
            let iHeightContainer = that.control.getHeightContainer();
            let yDiff = iHeightAllItems - iHeightContainer;
            let iNewHeight = that.height = that.height + yDiff;
            iNewHeight = Math.min(iNewHeight, maxWindowHeight);
            that.height = iNewHeight;
            if (that.top + iNewHeight > maxWindowHeight)
                // Da würde der Dialog aus dem sichtbaren Bereich unten hinauswachsen
                that.center();
        }
    }
    clear() {
        if (this.control)
            this.control.remove();
        this.control = undefined;
    }
}
exports.MVPickerAlternative1 = MVPickerAlternative1;
